import React, { useEffect, useState } from "react";
import { Col, Row, Typography, Checkbox, Button, Form, Input } from "antd";
import { PaperClipOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";

import { getFileName } from "../../../../helpers/getFileName";

const InsuranceResponseInfo = ({ actions, state }) => {
  const { currentOfferResponse, currentOfferRequest } = state;
  const { offerResponseId } = useParams();
  const navigate = useNavigate();
  const [isCorrectChecked, setIsCorrectChecked] = useState(false);
  const [isAcceptedChecked, setIsAcceptedChecked] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (!offerResponseId) {
      return;
    }

    actions.getOfferResponseById(offerResponseId);
  }, [offerResponseId]);

  useEffect(() => {
    if (!currentOfferResponse) {
      return;
    }

    if (currentOfferResponse.accepted !== null) {
      setIsAcceptedChecked(currentOfferResponse.accepted);
    }

    setIsCorrectChecked(currentOfferResponse.correct);
    form.setFieldsValue({
      ...currentOfferResponse,
      accepted:
        currentOfferResponse.accepted !== null
          ? currentOfferResponse.accepted
          : false,
    });
    actions.getRequestById(currentOfferResponse.offerRequestId);
  }, [currentOfferResponse]);

  const handleFileDownload = () => {
    if (offerResponseId) {
      actions.downloadFile(
        offerResponseId,
        getFileName(currentOfferResponse?.filePath)
      );
    }
  };

  // Step 5 - Update offer
  const onFinish = (values) => {
    if (
      values.leaseAgreementNumber === "" ||
      values.leaseAgreementNumber === null
    )
      delete values.leaseAgreementNumber;
    if (offerResponseId) {
      actions.updateOfferResponse(offerResponseId, values, navigate);
    }
  };

  const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 20 },
  };

  return (
    <div className="px-8 py-4">
      <Typography className="text-xl font-bold text-center mb-6 text-dark-blue">
        PONUDA ZA ZAHTJEV ZAHTJEV:
        <span className="text-light-blue-login ml-2">
          {currentOfferRequest?.name}
        </span>
      </Typography>
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <div className="flex flex-col">
            <div className="flex flex-col sm:flex-row my-2">
              <Typography className="w-full sm:w-1/3 sm:text-right pr-4">
                Osiguravajuće društvo:
              </Typography>
              <Typography className="w-full sm:w-2/3">
                {currentOfferRequest?.offerResponse?.find(
                  (response) =>
                    response.insurance.id === currentOfferResponse?.insuranceId
                )?.insurance.name || ""}
              </Typography>
            </div>

            <div className="flex flex-col sm:flex-row my-2">
              <Typography className="w-full sm:w-1/3 sm:text-right pr-4">
                Ko je odgovorio:
              </Typography>
              <div className="w-full sm:w-2/3">
                {currentOfferRequest?.offerResponse?.map((response) => (
                  <Typography key={response.insurance.id}>
                    {response.insurance.name}
                  </Typography>
                ))}
              </div>
            </div>

            <div className="flex flex-col sm:flex-row my-2">
              <Typography className="w-full sm:w-1/3 sm:text-right pr-4">
                Prilog:
              </Typography>
              <div className="flex items-center w-full sm:w-2/3 bg-light-gray">
                <PaperClipOutlined className="text-black opacity-45 mr-2" />
                <div
                  className="text-light-blue cursor-pointer"
                  onClick={handleFileDownload}
                >
                  {getFileName(currentOfferResponse?.filePath)}
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row my-2">
              <Typography className="w-full sm:w-1/3 sm:text-right pr-4">
                Premija AK:
              </Typography>
              <Typography className="w-full sm:w-2/3">
                {currentOfferResponse?.premiumAO}
              </Typography>
            </div>

            <div className="flex flex-col sm:flex-row my-2">
              <Typography className="w-full sm:w-1/3 sm:text-right pr-4">
                Premija AO:
              </Typography>
              <Typography className="w-full sm:w-2/3">
                {currentOfferResponse?.premiumAO}
              </Typography>
            </div>

            <div className="flex flex-col sm:flex-row my-2">
              <Typography className="w-full sm:w-1/3 sm:text-right pr-4">
                Full troškovi registracije:
              </Typography>
              <Typography className="w-full sm:w-2/3">
                {currentOfferResponse?.fullRegistrationCost}
              </Typography>
            </div>

            <div className="flex flex-col sm:flex-row my-2">
              <Typography className="w-full sm:w-1/3 sm:text-right pr-4">
                Napomena:
              </Typography>
              <Typography className="w-full sm:w-2/3">
                {currentOfferResponse?.note}
              </Typography>
            </div>

            {currentOfferResponse?.correct && (
              <Button
                type="primary"
                htmlType="button"
                onClick={() => form.submit()}
                className="bg-light-blue ml-0 md:ml-16 my-6 font-medium w-full md:w-[132px] rounded-sm text-white"
                disabled={currentOfferResponse?.accepted}
              >
                DOPUNI
              </Button>
            )}
          </div>
        </Col>
        <Col xs={24} md={12} className="flex justify-center md:justify-start">
          <div className="text-center md:text-left">
            <div>
              <Typography className="text-base font-bold text-dark-blue mb-2">
                OCJENA PONUDE
              </Typography>
              <Checkbox
                checked={isCorrectChecked}
                onChange={(e) => {
                  setIsCorrectChecked(e.target.checked);
                }}
                disabled={true}
              >
                ISPRAVNA PONUDA
              </Checkbox>
            </div>
            {currentOfferResponse?.correct ? (
              <Form
                {...layout}
                form={form}
                name="basic"
                onFinish={onFinish}
                className="mt-4 bg-dashed-box border border-dashed border-light-blue-login py-4 pl-5 pr-10"
                disabled={currentOfferResponse?.accepted}
              >
                <Typography className="text-base font-bold text-dark-blue mb-2">
                  STATUS PONUDE
                </Typography>
                <Form.Item name="accepted" valuePropName="checked">
                  <Checkbox
                    checked={isAcceptedChecked}
                    onChange={(e) => {
                      setIsAcceptedChecked(e.target.checked);
                    }}
                  >
                    PRIHVAĆENA PONUDA
                  </Checkbox>
                </Form.Item>
                <Form.Item
                  label="Broj leasing ugovora"
                  name="leaseAgreementNumber"
                  wrapperCol={{ span: 14 }}
                  rules={[
                    {
                      required: isAcceptedChecked,
                      message: "Unesite broj leasinga ugovora!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Typography className="text-base font-bold text-dark-blue mb-2">
                  DETALJI PONUDE
                </Typography>
                <Form.Item
                  label="Godina proizvodnje"
                  name="yearOfManufacture"
                  rules={[
                    {
                      required: true,
                      message: "Unesite godinu proizvodnje!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Marka vozila"
                  name="vehicleBrand"
                  rules={[
                    {
                      required: true,
                      message: "Unesite marku vozila!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Tip vozila"
                  name="vehicleType"
                  rules={[
                    {
                      required: true,
                      message: "Unesite tip vozila!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Broj šasije"
                  name="chassisNumber"
                  rules={[
                    {
                      required: true,
                      message: "Unesite broj šasije!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Form>
            ) : (
              <div className="mt-4">
                <Typography className="text-base font-bold text-dark-blue mb-2">
                  STATUS PONUDE
                </Typography>
                <Typography className="text-sm font-bold text-estimate-fail mb-2">
                  NIJE PRIHVAĆENA
                </Typography>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default InsuranceResponseInfo;
